import React, { useState, useRef, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthContext from "./context/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PrivateRoute from "./components/PrivateRoute";
import Profile from "./pages/Profile";
import UserSettings from "./pages/UserSettings";
import Sidebar from "./components/Sidebar";
import Create from "./pages/Create";
import PostStatic from "./components/PostStatic";
import OccurrencePreview from "./components/OccurrencePreview";
import TagFeed from "./pages/TagFeed";
import Saved from "./pages/Saved";
import Notifications from "./components/Notifications";
import { ModalProvider } from "./components/ModalManager";

import SearchPage from "./pages/SearchPage";
import Messages from "./pages/Messages";
import MediaLibrary from "./pages/MediaLibrary";
import CalendarPage from "./pages/Calendar";
import NotFound from "./components/NotFound";
import ResetPassword from "./pages/ResetPassword";

function AuthenticatedApp({ handleToggleNotifications, showNotifications, buttonRef }) {
  const location = useLocation();
  const backgroundLocation = location.state && location.state.backgroundLocation;

  return (
    // TODO: create size layouts
    <div className="flex h-screen w-screen">
      <ModalProvider>
        <div>
          <Sidebar toggleNotifications={handleToggleNotifications} buttonRef={buttonRef} />
        </div>
        {showNotifications && (
          <div>
            <Notifications onClose={handleToggleNotifications} buttonRef={buttonRef} />
          </div>
        )}
        <div className="p-4 pb-24 sm:pb-2 sm:ml-20 xl:ml-56 transition-[margin] duration-200 flex-1 min-w-0 ">
          <Routes location={backgroundLocation || location}>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Home />} />
              <Route path="/posts/:id" element={<PostStatic />} />
              <Route path="/occurrences/:id" element={<OccurrencePreview />} />
              <Route path="/create" element={<Create />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/messages/t/:t_id" element={<Messages />} />
              <Route path="/profiles/:username" element={<Profile />} />
              <Route path="/tags/:tagName" element={<TagFeed />} />
              <Route path="/profiles/settings" element={<UserSettings />} />
              <Route path="/saved" element={<Saved />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/media" element={<MediaLibrary />} />
              <Route path="/calendar" element={<CalendarPage />} />
            </Route>

            <Route path="/login" element={<Navigate to="/" />} />
            <Route path="/signup" element={<Navigate to="/" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          {backgroundLocation && (
            <Routes>
              <Route path="/posts/:id" element={<PostStatic />} />
              <Route path="/occurrences/:id" element={<OccurrencePreview />} />
            </Routes>
          )}
        </div>
      </ModalProvider>
    </div>
  );
}

function UnauthenticatedApp() {
  return (
    <div className="flex h-screen w-screen">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

function App() {
  const { user, token } = useContext(AuthContext);
  const [showNotifications, setShowNotifications] = useState(false);
  const buttonRef = useRef();

  const handleToggleNotifications = () => {
    setShowNotifications((prev) => !prev);
  };

  return (
    <Router>
      {token ? (
        <AuthenticatedApp
          handleToggleNotifications={handleToggleNotifications}
          showNotifications={showNotifications}
          buttonRef={buttonRef}
        />
      ) : (
        <UnauthenticatedApp />
      )}
    </Router>
  );
}

export default App;
